import { Rating } from 'schema-dts';
import { getRatingValue } from './utils';

/**
 *
 * @param val Expects a value between 0 and 10, which will then be normalized to 0 and 5.
 * @returns Rating
 */
export function rating(val: number | undefined | null): Rating {
  return {
    '@type': 'Rating',
    worstRating: 0,
    bestRating: 5,
    ratingValue: getRatingValue(val),
  };
}
